import {DOT_DENSITY,normalizeDotDensity} from './dot-pattern.js';
import './studio-refinements.css';

export default function StudioDotControls({layers,drawing,onDrawSettings,onPatchNail,onToggle,dragProps,children}) {
 const dotLayer=layers.findLast(layer=>layer.kind==='pattern'&&layer.type==='dots'&&layer.visible!==false&&layer.opacity!==0);
 const density=normalizeDotDensity(dotLayer?.dotDensity??drawing.dotDensity);
 const changeDensity=value=>{
  const dotDensity=normalizeDotDensity(value);onDrawSettings({dotDensity});
  onPatchNail(nail=>({layers:nail.layers.map(layer=>layer.kind==='pattern'&&layer.type==='dots'?{...layer,dotDensity}:layer)}));
 };
 return <>
  <label className="st-range"><span>波点密度<output>{density}%</output></span><input type="range" aria-label="波点密度" min={DOT_DENSITY.min} max={DOT_DENSITY.max} step={DOT_DENSITY.step} value={density} onChange={e=>changeDensity(Number(e.target.value))}/></label>
  <div className="st-dot-actions"><button type="button" className="st-wide-button" {...dragProps} onClick={onToggle}>{dotLayer?'移除波点':'添加波点'} {children}</button><button type="button" className={drawing.tool==='dot-eraser'?'active':''} aria-pressed={drawing.tool==='dot-eraser'} onClick={()=>onDrawSettings({tool:drawing.tool==='dot-eraser'?'select':'dot-eraser'})}>{drawing.tool==='dot-eraser'?'完成擦除':'擦除波点'}</button></div>
  <p className="st-help">调整密度增加或减少圆点；开启擦除后，轻点或划过不要的圆点。</p>
 </>;
}
